import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import StoriaPage from "@/pages/StoriaPage";
import MenuPage from "@/pages/MenuPage";
import GalleriaPage from "@/pages/GalleriaPage";
import PrenotazioniPage from "@/pages/PrenotazioniPage";
import ContattiPage from "@/pages/ContattiPage";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/storia" element={<StoriaPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/galleria" element={<GalleriaPage />} />
          <Route path="/prenotazioni" element={<PrenotazioniPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
